import { Marker } from './marker'

// NOTE: if we don't have a `get` option, the result can always potentially be
// `undefined`
export function property<TIn, TOut, TStored>(
  config: Required.Semi<
    PropertyConfig.WithoutMarker<TIn, TOut, TStored>,
    'get' | 'set'
  >,
): Required.Semi<PropertyConfig<TIn, TOut, TStored>, 'get' | 'set'>
export function property<TIn, TOut>(
  config: Required.Semi<PropertyConfig.WithoutMarker<TIn, TOut>, 'set'>,
): Required.Semi<PropertyConfig<TIn, TOut | undefined>, 'set'>
export function property<TOut, TStored>(
  config: Required.Semi<
    PropertyConfig.WithoutMarker<TStored, TOut, TStored>,
    'get'
  >,
): Required.Semi<PropertyConfig<TStored, TOut, TStored>, 'get'>
export function property<T>(
  config?: PropertyConfig.WithoutMarker<T>,
): PropertyConfig<T, T | undefined>

export function property<TIn, TOut, TStored>(
  config: PropertyConfig.WithoutMarker<TIn, TOut, TStored> = {},
): PropertyConfig<TIn, TOut, TStored> {
  return Marker.mark(config, Marker.Type.Property)
}

export interface PropertyConfig<TIn, TOut = TIn, TStored = TOut>
  extends Marker<Marker.Type.Property> {
  readonly get?: (stored: TStored | undefined) => TOut
  readonly set?: (
    input: TIn,
    current: TStored | undefined,
  ) => TStored | undefined
}
export namespace PropertyConfig {
  export type Constraint<TIn = any, TOut = any, TStored = any> = PropertyConfig<
    TIn,
    TOut,
    TStored
  >

  export type Default<
    TIn = unknown,
    TOut = unknown,
    TStored = unknown,
  > = PropertyConfig<TIn, TOut, TStored>

  export type WithoutMarker<TIn, TOut = TIn, TStored = TOut> = Difference<
    PropertyConfig<TIn, TOut, TStored>,
    Marker<Marker.Type.Property>
  >
}
